<template>
    <EventCollectionPage v-if="pageData.data" v-bind="pageData.data" />
</template>

<script setup>
import EventCollectionFragment from '@fragments/pages/EventCollectionFragment';

const pageData = await usePageData(EventCollectionFragment);
</script>
